/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_New_Folder_ButtonInputs */



/**
* | output |
* | --- |
* | "Folder" |
*
* @param {Explorer_Nav_New_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_new_folder_button = /** @type {((inputs?: Explorer_Nav_New_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_New_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Папка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pasta")
	return /** @type {LocalizedString} */ ("Folder")
});